//devnet
export const environment = {
  production: false,
  server: "aws", // This will be overwritten by the script during build time
  sol: {
    chainIdInt: 103,
    usdcTokenAddress: 'DZhmFKmhiahcfd2o2RVE7jNGGrZnL7KNUgEh7huWXE1r', //USDC TOKEN ADDRESS
    usdtTokenAddress: 'usdRjXs6N7e2EHKtinvYQhds2Y4uTpSYrYd5iNAw6Vq', //USDT TOKEN ADDRESS
    presaleAddress: '5Bz2ohK6srpp8M4EYXJGVS92fBe62cjn6yYamcemKRLw',
    SolRpcUrl: 'https://api.devnet.solana.com',
    SolBackupRpcUrl: 'https://api.devnet.solana.com',
    otherAccountUsdc: 'A5PXBRWzy3dT3e4y332MnoHSiio7ujpcm9sUALmyttRd', // USDC TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountUsdt: '55yoz1i8ebLVDCwRRM2XusQjP1ZgKpeebvDTsHwypCsu', // USDT TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountSol: '67TyzJqxjKjmCjH3gdABV2TrAuZckLMwh5uXc4RpPjpm', // WALLET ADDRESS
    chainlinkFeed: '99B2bTijsU6f1GCT73HmdR7HCFFjGMBcPZY6jZ96ynrR', // USED TO FETCH SOL CURRENT PRIZE, THIS VARIOUS ACCORDING TO TOKEN
    chainlinkProgram: 'HEvSKofvBgfaexv23kMabbYqxasxU3mQ4ibBMEmJWHny', // USED FOR CHAIN LINK FEED, REMAINS SAME FOR ALL TOKENS
    gasFees: 0.0001,
    blockExplorerURL: 'https://solscan.io/tx/',
  },
  eth: {
    chainId: '0xaa36a7', //hexadecimal for metamask
    chainIdInt: 11155111,
    chainName: 'Ethereum Mainnet',
    gasFees: 0,
    purchaseToken: 'ETH',
    hasStaking: true,
    nativeFunction: 'buyWithEth',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x34a599Fe3496C1A3308776F7369F8eC2Ff6cAc9B',
    usdTAddress: '0x9fa2AE3c0a571BbBFd17E74d7470b6c444A87aF2',
    usdcAddress: '0x232331e4e45582742A2D717562Cd682fA132b799',
    rpcURL: 'https://1rpc.io/sepolia',
    backupRPC: 'https://1rpc.io/sepolia',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0xaa36a7',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  bsc: {
    chainId: '0x61', //hexadecimal for metamask
    chainIdInt: 97,
    chainName: 'BSC Mainnet',
    gasFees: 0,
    purchaseToken: 'BNB',
    hasStaking: false,
    nativeFunction: 'buyWithBNB',
    presaleAddress: '0x0001e0Dfc9ba85b697754045daD08b765F1B663e',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    usdTAddress: '0xADFc9B54FB7a1677176A7529F03b91081C91355c',
    usdcAddress: '0xF4053F70d6cC72C0473F2a9E42176DB818D24454',
    rpcURL: 'https://bsc-testnet-rpc.publicnode.com',
    backupRPC: 'https://bsc-testnet-rpc.publicnode.com',
    blockExplorerURL: 'https://bscscan.com/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x61',
          chainName: 'BSC Mainnet',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
          },
          rpcUrls: ['https://bsc-dataseed.binance.org'],
          blockExplorerUrls: ['https://bscscan.com/'],
        },
      ],
    },
  },

  minToken: 0,
  stakingAddress: '0x478da5f3bE80e2A1EA0E50481973BBFFaC00f4fC',
  apyCalcConst: 416666667,
  stakeUnlockTime: 1912943476000, // add 7 days epoch time in milliseconds with the claim activation time
  robots: 'noindex, follow',
  tokenName: '$TALC',
  iidDashFx: 0,
  urlDashFx_aws: '',
  urlDashFx_firebase: '',
  urlDashFx_cloudfront: '',
  wertOrigin: 'https://sandbox.wert.io', // testnet
  partnerId: '01HK57C8XMFEVRTMAW55NBD9W2', // testnet
  wertUrl: 'https://ijs2jkwmnzohnnjppqkypl2avq0hhlcm.lambda-url.eu-west-2.on.aws/', // testnet
  referUrl: 'https://fztdp5he4ueq4nytzyj2ycx7vm0wwqth.lambda-url.eu-west-2.on.aws/',
  bwUniversalLink: 'https://best-wallet-dev.web.app',
  bwDeepLink: 'bw-dev://app/connect?',
  bwApiUrl: 'https://d19yvvzbif6vnj.cloudfront.net/webhook-service-api/presale',
  showBestWallet: false,
  domain: 'https://dr6ihoyj2tuf.cloudfront.net', // replace with live site URL [NO SLASH IN THE END]
  sseUrl: '',
  notificationTimeout: 7000,
  presaleName: 'ICO-Boilerplate',
  presale_singular_link: '',
  post_presale_singular_link: '',
  wertOnRampUrl: '', // will change according to the presales.
  twitterId: '@ICO_TWIT', // twitter handler id. i.e. '@abc_TWIT',
  reownProductId: '4c9c7ef0bfd4254308c0516f200d0105',
  isVwoEnabled: false,
  isClaimEnabled: false, // need to set it true when claim is live,
  solGasAddress: '4WzwRDFh4JCNcdfYGUdsHche8uYw8T8f55nMTeG6UojU', // SOL GAS WALLET ADDRESS
  wertSigner: 'CYdZAb4i2oaz5CiAvwenMyUVm2DJdd2cWKsekKxxXCQX',
  crmPixelUrl: 'https://d1zf7cen38fcax.cloudfront.net/',
  crmPixelApiKey: '9JIT77Nabj4qvk2aFqvgk1JFmr7GrKUg4wybMLza', //add api key here, will be provided by the crm team, this is a placeholder testing key
  slug: 'Boilerplate',
  pixelEnv: 'staging',
  crmPixelEventsApiUrl: 'https://d4pkym2fwup68.cloudfront.net/events',
  gasAddress: '0x0000000000000000000000000000000000000001',
};
